// Premium types: what is being bought. Sub-bands sit under one of these.
export const PREMIUM_TYPE_ORDER = ['individual', 'family', 'dependent'];
export const PREMIUM_TYPE_LABEL = {
  individual: 'Individual',
  family: 'Family',
  dependent: 'Additional dependent',
};
export const PREMIUM_TYPE_HELP = {
  individual: 'One member.',
  family: 'A family sub-band; each carries the members it covers.',
  dependent: 'Age categories that can be added, in any quantity, to an Individual or Family purchase.',
};
export function ageRangeLabel(band) {
  if (!band || (band.min_age == null && band.max_age == null)) return '';
  if (band.min_age != null && band.max_age != null) return `ages ${band.min_age}–${band.max_age}`;
  if (band.min_age != null) return `ages ${band.min_age}+`;
  return `up to age ${band.max_age}`;
}
export function subBandSubtitle(band) {
  const t = band?.premium_type;
  if (t === 'dependent') return ageRangeLabel(band);
  if (t === 'individual') return '1 member';
  return band?.max_members ? `up to ${band.max_members} member${Number(band.max_members) > 1 ? 's' : ''}` : 'composition rule not set';
}
export function groupByPremiumType(bands = []) {
  const groups = { individual: [], family: [], dependent: [] };
  bands.forEach((b) => { (groups[b.premium_type] || groups.family).push(b); });
  return groups;
}

// Pricing nature of a dependent category on a plan — configuration, never code.
export const PRICING_MODE_ORDER = ['fixed', 'percent_of_individual', 'same_as_individual'];
export const PRICING_MODE_LABEL = {
  fixed: 'Fixed amount',
  percent_of_individual: '% of the Individual price',
  same_as_individual: 'Same as the Individual price',
};
export function pricingModeSummary(row) {
  const mode = row?.pricing_mode || 'fixed';
  if (mode === 'percent_of_individual') return `${Number(row.pricing_percent || 0)}% of Individual`;
  if (mode === 'same_as_individual') return 'same as Individual';
  return 'fixed';
}
